(function () {
  var wrap = document.getElementById('folksWaFabWrap');
  if (!wrap) return;

  var link = wrap.querySelector('.folks-wa-fab');
  var hero = document.querySelector('.folks-carousel');

  function shouldShow() {
    if (hero) {
      return hero.getBoundingClientRect().bottom < window.innerHeight * 0.72;
    }
    return window.scrollY > 320;
  }

  function update() {
    var show = shouldShow();
    wrap.classList.toggle('folks-wa-fab-wrap--visible', show);
    wrap.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (link) {
      link.tabIndex = show ? 0 : -1;
    }
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('orientationchange', update);
})();
